// @ts-nocheck
import { useRequestQuery } from '../../useQueryRequest';
import { useDownloadFile } from '../../useDownloadFile';
import { useRequestPdf } from '../../useRequestPdf';
import { IVATDeclarationTable, VATDeclarationQuery } from '@/interfaces/VATDeclaration';
import t from '../types'; // Import type constants

/**
 * Validates that dates in query are proper strings and not empty objects
 */
const isValidQuery = (query: VATDeclarationQuery): boolean => {
  const { from_date, to_date } = query;
  return (
    typeof from_date === 'string' && 
    from_date.length > 0 &&
    typeof to_date === 'string' && 
    to_date.length > 0
  );
};

/**
 * Retrieves the VAT Declaration report.
 */
export function useVATDeclaration(query: VATDeclarationQuery, props = {}) {
  console.log(query, "query");
  return useRequestQuery<IVATDeclarationTable>(
    [t.FINANCIAL_REPORT, 'VAT_DECLARATION', query], // Use type constant and unique key
    {
      method: 'get',
      url: '/financial_statements/vat-declaration', // Correct endpoint
      params: query,
      headers: {
        Accept: 'application/json+table',
      },
    },
    {
      select: (res) => res.data, // Select the data part of the response
      enabled: isValidQuery(query), // Only run query if dates are set
      ...props,
    },
  );
}

/**
 * Hook for downloading VAT Declaration as XLSX.
 */
export const useVATDeclarationXlsxExport = (query, args) => {
  return useDownloadFile({
    url: '/financial_statements/vat-declaration',
    config: {
      headers: {
        accept: 'application/xlsx',
      },
      params: query,
    },
    filename: 'vat_declaration.xlsx',
    ...args,
  });
};

/**
 * Hook for downloading VAT Declaration as CSV.
 */
export const useVATDeclarationCsvExport = (query, args) => {
  return useDownloadFile({
    url: '/financial_statements/vat-declaration',
    config: {
      headers: {
        accept: 'application/csv',
      },
      params: query,
    },
    filename: 'vat_declaration.csv',
    ...args,
  });
};

/**
 * Hook for downloading VAT Declaration as PDF.
 */
export function useVATDeclarationPdf(query = {}) {
  return useRequestPdf({
    url: `/financial_statements/vat-declaration`,
    params: query,
  });
} 